import { render, staticRenderFns } from "./EventMarkers.vue?vue&type=template&id=a248b1b2&scoped=true"
import script from "./EventMarkers.vue?vue&type=script&lang=js"
export * from "./EventMarkers.vue?vue&type=script&lang=js"
import style0 from "./EventMarkers.vue?vue&type=style&index=0&id=a248b1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a248b1b2",
  null
  
)

export default component.exports